// Keyset-paged list endpoints (conversations, runs, ...) answer with an
// `X-Next-Cursor: <updated_at_iso>,<id>` header while more rows exist. This
// turns it into the `after_updated_at` / `after_thread_id` query params of the
// next page (URLSearchParams encodes the "+" of the timezone offset), or null
// when there is no next page.
export function cursorParams(header, idParam = "after_thread_id") {
  if (!header) return null;
  const split = header.lastIndexOf(",");
  if (split <= 0 || split === header.length - 1) return null;
  const params = new URLSearchParams();
  params.set("after_updated_at", header.slice(0, split));
  params.set(idParam, header.slice(split + 1));
  return params;
}
